module.exports = __webpack_public_path__ + "img/thailand.1ace6981.svg";